import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import _fp from 'lodash/fp';
// import { get } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler, Slugify } from '@bd/bdcore-utilities';

import { colors } from '../../styles';

const styles = css`
  .PhotoCategories_title {
    background-color: rgba(0, 0, 0, 0.08);
    font-weight: 300;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0.81px;
    padding: 25px;
    text-transform: capitalize;
    @media(min-width: 992px) {
      padding: 60px 25px;
      font-size: 42px;
      letter-spacing: 1.31px;
      text-align: center;
    }
  }
  .PhotoCategories_list {
    flex-direction: column;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
    padding: 30px;
    position: absolute;
    top: 75px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 2rem);
    background-color: #FFFFFF;
    z-index: 10;
    flex-wrap: wrap;
    @media(min-width: 768px) {
      flex-direction: row;
      position: relative;
      left: auto;
      top: auto;
      transform: none;
      box-shadow: none;
    }
    justify-content: flex-start;
    align-items: center;
    li {
      width: 100%;
      @media(min-width: 768px) {
        width: max-content;
      }
      @media(min-width: 0\0) {
        width: auto !important;
      }
      & + li {
        border-top: 1px solid rgba(0,0,0,0.15);
        @media(min-width: 768px) {
          border: 0;

        }
      }
      a {
        padding: 0 15px;
        font-weight: 700;
        font-size: 14px;
        letter-spacing: 2.21px;
        line-height: 25px;
        text-transform: uppercase;
        transition: all .3s ease-out;
        color: #000000;
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 5px 0;
        @media(min-width: 768px) {
          justify-content: flex-start;
          font-size: 16px;
          letter-spacing: 2.91px;
          ${''/* padding: 8px 30px 0 0; */}
        }
        &:hover, &.active {
          color: ${colors.color1};
        }
      }
    }
  }
  .PhotoCategories_mobileBtn {
    background-color: #DADADA;
    font-weight: 900;
    font-size: 15px;
    color: #000000;
    letter-spacing: 0;
    line-height: 20px;
    width: 100%;
    height: 50px;
    align-items: center;
    display: flex;
    padding: 5px 20px;
    position: relative;
    cursor: pointer;
    &::after {
      content: '';
      position: absolute;
      top: 20px;
      right: 30px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 10px solid ${colors.color1};
    }
    &:focus {
      outline: none;
    }
  }
  .PhotoCategories_mobileBtnActive {
    &::after {
      border-top: 10px solid transparent;
      border-bottom: 10px solid ${colors.color1};
      top: 10px;
    }
  }

  .PhotoCategories_typesList {
    padding: 0;
    text-align: left;
    width: max-content;
    position: absolute;
    z-index: 10;
    left: 0;
    top: 50px;
    width: 100%;
    list-style: none;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
    background-color: #1F1F1F;
    padding: 30px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: none;
    @media(min-width: 768px) {
      max-width: 300px;
    }
    @media(min-width: 992px) {
      top: 70px;
      padding: 30px 15px;
      right: 0;
      left: unset;
    }
    &.open {
      display: flex;
    }
  }
  .PhotoCategories_typesListItem {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 15px;
    @media(min-width: 768px) {
      max-width: 600px;
    }
    & + li {
      border-top: 1px solid #151515;
    }
    a {
      font-weight: 700;
      color: #FFFFFF;
      font-size: 14px;
      letter-spacing: 1.81px;
      line-height: 30px;
      text-align: center;
      text-transform: uppercase;
      transition: all .3s ease-out;
      @media(min-width: 992px) {
        font-size: 17px;
        letter-spacing: 2.71px;
      }
      &.active, &:hover {
        color: ${colors.color1};
        font-weight: 700;
      }
    }
  }
  .PhotoCategories_typesBtn {
    height: 50px;
    width: 100%;
    background-color: ${colors.color1Darkest};
    font-weight: 700;
    font-size: 17px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 20px 0 0;
    @media(min-width: 768px) {
      width: 300px;
    }
    &:focus {
      outline: none;
    }
  }
`;

function PhotoCategories({ page, activateMenu, isActiveMenu, gallerySlug }) {
  const categories = _fp.flow([
    _fp.map('name'),
    _fp.uniq,
  ])(_fp.get('galleries', page));

  const mycategories = _fp.flow([
    _fp.map('name'),
    _fp.uniq,
    _fp.filter(cat => gallerySlug === Slugify(cat)),
  ])(_fp.get('galleries', page));

  return (
    <div className={styles}>
      <div className="PhotoCategories_title">{gallerySlug ? `${mycategories} Photos` : 'All Photos'}</div>
      <div className="d-lg-flex py-4 px-3 position-relative justicfy-content-center">
        <span onClick={activateMenu('category')} role="button" tabIndex="0" className={`d-md-none PhotoCategories_mobileBtn ${isActiveMenu('category') ? 'PhotoCategories_mobileBtnActive' : ''}`}>Photo Categories</span>
        <ul className={`list-unstyled justify-content-center PhotoCategories_list ${isActiveMenu('category') ? 'd-flex' : 'd-none d-md-flex'} w-100`}>
          {
            categories.map(item => (
              <li key={item} className="">
                <Link name="image-gallery" params={{ category: item }} className={gallerySlug === Slugify(item) ? 'active' : ''}>
                  {item}
                </Link>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

PhotoCategories.propTypes = {
  page: PropTypes.object.isRequired,
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  gallerySlug: PropTypes.string,
};

PhotoCategories.defaultProps = {
  gallerySlug: undefined,
};


export default menuToggler(PhotoCategories);



// WEBPACK FOOTER //
// ./src/pages/ImageGallery/PhotoCategories.js